import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastError = (err, { context = "generic", ...toastOptions } = {}) => {
	const errorMsg = err?.response?.data?.message || err?.response?.data?.error;
	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				...toastOptions,
				toastId: errorMsg,
			});
		} else {
			toast.error(errorMsg, {
				...toastOptions,
				toastId: errorMsg,
			});
		}
	} else {
		const isMessageSend = context === "message-send";
		toast.error(
			i18n.t(isMessageSend ? "errors.messageSend" : "errors.generic"),
			{
				...toastOptions,
				toastId:
					toastOptions.toastId ||
					(isMessageSend ? "message-send-error" : "generic-error"),
			}
		);
	}
};

export default toastError;
